import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white">
        <p className="font-display tracking-widest">LOADING…</p>
      </div>
    );
  }
  if (!user || user === false || user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
